var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrowTfi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uE829") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "String-correction-by-user",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-override",
    transform: "translate(-608.000000, -717.000000)",
    fill: "#002C56",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lookup-1-copy",
    transform: "translate(299.000000, 91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "override-column",
    transform: "translate(199.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\uE829",
    points: "130 538.772455 130 541.227545 114.790419 541.227545 121.766467 548.233533 120 550 110 540 120 530 121.766467 531.766467 114.790419 538.772455"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowTfi);
export default __webpack_public_path__ + "static/media/back_arrow_tfi.cc8e56f4fee5fd7e6fb8fa7f9d1053bb.svg";
export { ForwardRef as ReactComponent };